'use strict';
var base = require('base/product/base');
var detailBase = require('plugin_wishlists/product/details');
// PMangalore - Wishlist
// https://github.com/SalesforceCommerceCloud/plugin_wishlists/issues/99 see below as well
// var wishListJs = require('../../../../../../plugin_wishlists/cartridges/plugin_wishlists/cartridge/client/default/js/product/wishlist.js');
var detailExport = {};

[detailBase].forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        if (typeof library[item] === 'object') {
            detailExport[item] = $.extend({}, base[item], library[item]);
        } else {
            detailExport[item] = library[item];
        }
    });
});

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAddModel(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        base.chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        $('#add-to-cart-messages').remove();
        if (messageType === 'alert-danger') {
            clearTimeout(window.clrMsgTimeout);
            $('body').append('<div id="add-to-cart-messages" class="modal fade"  tabindex="-1" role="dialog"></div>');

            $('#add-to-cart-messages').addClass('error-add-to-cart-messages');
            $('#add-to-cart-messages').html('');
            $('#add-to-cart-messages').append('<div class="modal-dialog">'
                + '<div class="modal-content ' + messageType + '" msgtype="' + messageType + '">'
                + '<div class="atc-modal-header delete-confirmation-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>'
                + '<div class="modal-body">'
                + '<p>' + response.message + '</p>'
                + '</div>'
                + '</div>'
                + '</div>');
            $('#add-to-cart-messages').modal('show');

            $('body').off('click', '#add-to-cart-messages .atc-modal-header button.close');
            $('body').on('click', '#add-to-cart-messages .atc-modal-header button.close', function (e) {
                e.preventDefault();
                $('.modal-backdrop').remove();
                $('#add-to-cart-messages').remove();
            }); // 295791
        } else if (response.message.warning) {
            $('body').append('<div id="add-to-cart-warning-messages" class="error-add-to-cart-messages modal fade"  tabindex="-1" role="dialog"></div>');
            $('#add-to-cart-warning-messages').html('');
            $('#add-to-cart-warning-messages').append('<div class="modal-dialog">'
                    + '<div class="modal-content alert-warning" msgtype="' + messageType + '">'
                    + '<div class="atc-modal-header delete-confirmation-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>'
                    + '<div class="modal-body">'
                    + '<p>' + response.message.text + '</p>'
                    + '</div>'
                    + '</div>'
                    + '</div>');
            $('#add-to-cart-warning-messages').modal('show');
            $('body').off('click', '#add-to-cart-messages .atc-modal-header button.close');
            $('body').on('click', '#add-to-cart-messages .atc-modal-header button.close', function (e) {
                e.preventDefault();
                $('.modal-backdrop').remove();
                $('#add-to-cart-warning-messages').remove();
            });
        } else {
            $('body').append(
                '<div id="add-to-cart-messages" class="add-to-cart-messages"></div>'
            );

            $('#add-to-cart-messages').addClass('add-to-cart-messages');
            $('#add-to-cart-messages').html('');
            $('#add-to-cart-messages').append(
                '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                + response.message
                + '</div>'
            );

            window.clrMsgTimeout = setTimeout(function () {
                $('#add-to-cart-messages').remove();
            }, 5000);
        }
    }
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptionsPDP($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find('.carousel');
    $(carousel).carousel('dispose');
    var carouselId = $(carousel).attr('id');
    $(carousel).empty().append('<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('prev') + '</span></a><a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('next') + '</span></a>');
    for (var i = 0; i < imgs.length; i++) {
        $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel).find('.carousel-inner'));
        $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class=""></li>').appendTo($(carousel).find('.carousel-indicators'));
    }
    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
    if (imgs.length === 1) {
        $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
    }
    $(carousel).carousel();
    $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);
}
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.price', $productContainer);
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}
function getQuantitySelector($el) {
    return $el && $('.set-items').length
        ? $($el).closest('.product-detail').find('.quantity-select')
        : $('.quantity-select');
}
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * appends params to a url
 * @param {Object} $elementAppendTo - data returned from the server's ajax call
 * @param {string} msg - icon that was clicked to add a product to the wishlist
*/
function displayErrorMessage($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append(
            '<div class="remove-from-wishlist-messages "></div>'
        );
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        $('.wishlistItemCards').empty();
        $('body .wishlistItemCards').append(data);

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

/**
 * Add an item to a localStorage() array
 * @param {String} name  The localStorage() key
 * @param {String} value The localStorage() value
 */

function addToLocalWishlist(name, value) {
    var existing = localStorage.getItem(name);
    existing = existing ? existing.split(',') : [];
    existing.push(value);
    localStorage.setItem(name, existing.toString());
}

function removeFromLocalWishlist(name, value) {
    var existing = localStorage.getItem(name);
    existing = existing ? existing.split(',') : [];
    var eIndex = existing.indexOf(value);
    existing.splice(eIndex, 1);
    localStorage.setItem(name, existing.toString());
}

// PMangalore - Wishlist
// https://github.com/SalesforceCommerceCloud/plugin_wishlists/issues/99 see below as well
// This function exists in wishlist cartridge but is not part of module export so we probably will need this to display our own custom success message to user
function displayMessage(data, button) {
    $.spinner().stop();
    /**
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }
    // if ($('.add-to-wishlist-messages').length === 0) {
    //     $('body').append(
    //     '<div class="add-to-wishlist-messages "></div>'
    //     );
    // }
    // $('.add-to-wishlist-messages')
    //     .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    // setTimeout(function () {
    //     $('.add-to-wishlist-messages').remove();
    //     button.removeAttr('disabled');
    // }, 5000);

    // if ($('.attributes .row').length > 0) {
        // $('.attributes .row')[0].prepend(status);
    // }
    // $('.attributes')[0].innerHTML = '<div style="background-color: white; margin:5, 5, 5, 5" class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>';
    */
    setTimeout(function () {
        // $('.attributes .row').remove();
        button.removeAttr('disabled');
    }, 5000);
}

detailExport.selectStartDate = function () {
    $(document).on('change', '.start-date__wrapper input', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        attributeSelect(e.currentTarget.value, $productContainer);
    });
};
detailExport.addToCart = function () {
    $(document).off('click', 'button.add-to-cart, button.add-to-cart-global');
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptionsPDP($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = base.getPidValue($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        addToCartUrl = $('.add-to-cart-url').val();
        var childProducts = [];
        $('.bundle-item').each(function () {
            childProducts.push({
                pid: $(this).find('.product-id').text(),
                quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
            });
        });

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: childProducts.length ? JSON.stringify(childProducts) : [],
            quantity: base.getQuantitySelected($(this))
        };

        if (!$('.bundle-item').length) {
            form.options = getOptionsPDP($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAddModel(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $.spinner().stop();
                    base.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

function loadauthAccountModel(name, value) {
    $('#authAccountModal').modal({
        backdrop: 'static',
        keyboard: false
    });
    $('#authAccountModal').attr("data-pid", value);
    $('#authAccountClose').attr("data-url", name);
}
// 86401
$(document).ready(function () {
    var userAuth = $('.product-detail.s-pdp').data('iscustomerauthenticated');
    if (userAuth) {
        var datapiwli = $('.product-detail.s-pdp').data('prodsinwishlist');
        if (datapiwli !== '') {
            datapiwli = datapiwli ? datapiwli.split(',') : [];
            localStorage.setItem('prodsinwishlist', datapiwli.toString());
            // 91784
            for (var i = 0; i < datapiwli.length; i++) {
                $('.productId[data-pid=' + datapiwli[i] + '] .btn-to-wish-list').removeClass("add-to-wish-list").addClass("removeFromWishlist wishlist-product-isadded").find('.wish-list-text')
                .text('Added to Favorites');
            }
        } else {
            localStorage.removeItem('prodsinwishlist');
        }
    } else {
        localStorage.removeItem('prodsinwishlist');
    }
    // 176669, 176670
    if ($('ul.timeline-styled').length >= 1) {
        $('.timeline-styled li p, .timeline-styled li h4, .timeline-styled li h3').each(function () {
            if ($(this).is(':empty')) {
                $(this).remove();
            }
            var $headingStyle = $('.timeline-styled li h4,#pdpFeatures .tile-content h4');
            $headingStyle.replaceWith(function () {
                return $('<h3/>', {
                    html: this.innerHTML
                });
            });
        });
    }
});

// PMangalore - Wishlist
// https://github.com/SalesforceCommerceCloud/plugin_wishlists/issues/99
// If resolved, no need for overriding the wishlist JS function. However, wishlist plugin has its own function for displaying success message. So we might
// have no escape from overriding this.
// detailExport.addToWishlist = wishListJs.addToWishlist;
detailExport.addToWishlist = function () {
    $('body').on('click', '.add-to-wish-list', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var button = $(this);
        var dataurl = $(this).data('url');
        var pid = $(this).closest('.productId').data('pid');
        // var pid = $(this).closest('.product-detail').find('.product-id').html();
        if (pid === undefined) {
            pid = base.getPidValue($(this));
        }
        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        var userAuth = $(this).closest('.product-detail').data('iscustomerauthenticated');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                if (!userAuth) {
                    loadauthAccountModel(dataurl, pid);
                } else {
                    button.removeClass("add-to-wish-list");
                    button.addClass("removeFromWishlist wishlist-product-isadded");
                    button.find('.wish-list-text').text('Added to Favorites'); // 91784
                    addToLocalWishlist('prodsinwishlist', pid);
                }
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};
detailExport.removeFromWishlist = function () {
    $(document).on('click', '.removeFromWishlist', function (e) {
        e.preventDefault();
        var button = $(this);
        var url = $(this).attr('data-url');
        var pid = $('.productId').attr('data-pid');
        var elMyAccount = $('.account-wishlist-item').length;
        // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
        if (elMyAccount > 0) {
            $('.wishlist-account-card').spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                data: {},
                success: function (html) {
                    $('.productId[data-pid=' + pid + ']').find('.btn-to-wish-list').removeClass("removeFromWishlist").addClass("add-to-wish-list");
                    $('.wishlist-account-card>.card').remove();
                    $('.wishlist-account-card').append(html);
                    $('.wishlist-account-card').spinner().stop();
                    removeFromLocalWishlist('prodsinwishlist', pid);
                    // button.removeClass("removeFromWishlist wishlist-product-isadded");
                    // button.addClass("add-to-wish-list");
                },
                error: function () {
                    var $elToAppend = $('.wishlist-account-card');
                    $elToAppend.spinner().stop();
                    var msg = $elToAppend.data('error-msg');
                    displayErrorMessage($elToAppend, msg);
                }
            });
            // else user is in wishlist landing page, call removeProduct() end point, then remove this card
        } else {
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {},
                success: function () {
                    $('[data-pid=' + pid + ']').find('.btn-to-wish-list').removeClass("removeFromWishlist").addClass("add-to-wish-list");
                    button.find('.wish-list-text').text('Add to Favorites'); // 91784
                    var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(pageNumber, false);
                    removeFromLocalWishlist('prodsinwishlist', pid);
                    // button.removeClass("removeFromWishlist wishlist-product-isadded");
                    // button.addClass("add-to-wish-list");
                },
                error: function () {
                    $.spinner().stop();
                    var $elToAppendWL = $('.wishlistItemCards');
                    var msg = $elToAppendWL.data('error-msg');
                    displayErrorMessage($elToAppendWL, msg);
                }
            });
        }
    });
};

module.exports = detailExport;
